import React, { useEffect, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation, useNavigationType } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import Layout from './components/Layout';
import './index.css';
const Home = React.lazy(() => import('./screens/Home'));
const StoryLibrary = React.lazy(() => import('./screens/StoryLibrary'));
const StoryPlay = React.lazy(() => import('./screens/StoryPlay'));
const Voice = React.lazy(() => import('./screens/Voice'));
const Family = React.lazy(() => import('./screens/Family'));
const JoinFamily = React.lazy(() => import('./screens/JoinFamily'));
const JoinEmail = React.lazy(() => import('./screens/JoinEmail'));
const Favorites = React.lazy(() => import('./screens/Favorites'));
const Profile = React.lazy(() => import('./screens/Profile'));
const Subscription = React.lazy(() => import('./screens/Subscription'));
const Legal = React.lazy(() => import('./screens/Legal'));
const Support = React.lazy(() => import('./screens/Support'));
const Onboarding = React.lazy(() => import('./screens/Onboarding'));
const Main = React.lazy(() => import('./screens/Main'));
const AuthCallback = React.lazy(() => import('./screens/AuthCallback'));
const ScrollToTop = () => {
  const { pathname } = useLocation();
  const navType = useNavigationType();
  useEffect(() => { if (navType !== 'POP') window.scrollTo(0, 0); }, [pathname, navType]);
  return null;
};

function App() {
  return (
    <ThemeProvider>
      <Router>
        <ScrollToTop />
        <Suspense fallback={<div style={{minHeight:'100vh',background:'#0B1120',display:'flex',alignItems:'center',justifyContent:'center'}}><div style={{color:'#F5C842',fontSize:24}}>✨</div></div>}>
        <Routes>
          {/* Main entry - Welcome/Login */}
          <Route path="/" element={localStorage.getItem('token') ? <Navigate to="/app" replace /> : <Main />} />

          {/* Auth */}
          <Route path="/auth-callback" element={<AuthCallback />} />
          <Route path="/onboarding" element={<Onboarding />} />

          {/* Join family */}
          <Route path="/join" element={<JoinFamily />} />
          <Route path="/join/:code" element={<JoinFamily />} />
          <Route path="/join/:code/email" element={<JoinEmail />} />

          {/* Story */}
          <Route path="/story/:slug" element={<StoryPlay />} />

          {/* App with nav */}
          <Route path="/app" element={<Layout />}>
            {/* Home is now the default */}
            <Route index element={<Home />} />
            <Route path="home" element={<Home />} />
            <Route path="library" element={<StoryLibrary />} />
            <Route path="favorites" element={<Favorites />} />
            <Route path="voice" element={<Voice />} />
            <Route path="family" element={<Family />} />
            <Route path="profile" element={<Profile />} />
            <Route path="subscription" element={<Subscription />} />
            <Route path="legal/:page" element={<Legal />} />
            <Route path="support" element={<Support />} />
          </Route>
        </Routes>
        </Suspense>
      </Router>
    </ThemeProvider>
  );
}

export default App;
